// extracted by mini-css-extract-plugin
export default {"business_items":"BusinessList_business_items__Bnukx"};